import React, { useCallback, useEffect, useState } from "react";
import { Api, BaseUrl, ImagePath1 } from "../../Config/Api";
import { toast } from "react-toastify";
import axios from "axios";
import "../../Admin/AdminPage/AdminNewPage/Style/SingleEmployeeAttendance.css"
import { COLOR, FONT, IMAGE } from "../../Config/Color";
import PullToRefresh from "react-simple-pull-to-refresh";
import { Table } from "antd";
import MainLayout from "../../../layouts/MainLayout";
import { getEmployeeProfile } from "../../../redux/actions/employeeActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ProfileDetailsCard from "../../Component/ProfileDetailsCard";
import AssetsPreview from "../../../modals/AssetsPreview";
import { convertToDecimalHours } from "../../../helpers/DateFormate";

const EmployeeAttendance = () => {
  const employeeId = sessionStorage.getItem("employeeId");
  const token = sessionStorage.getItem("authToken");
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const setLoading = () => { };
  const logout = () => { };
  const [attendanceData, setAttandanceData] = useState([]);
  const [filteredLeaveData, setFilteredLeaveData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const dispatch = useDispatch()
  const profileData = useSelector((state) => state.employeeData?.profile)
  const [countData, setcountData] = useState({
    leave: 0,
    onTime: 0,
    halfDay: 0,
    late: 0,
  });

  const fetchEmployeeAttendance = useCallback(async () => {
    setLoading(true);
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_EMPLOYEE_ATTENDANCE}?employee_id=${employeeId}`,
        {
          headers: {
            "X-Company-ID": userDetails.company_id,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0]);
        logout();
      } else {
        if (responseData?.data?.valid === false) {
          setLoading(false);
          toast.error(responseData?.data?.mssg[0]);
        } else {
          setAttandanceData(responseData?.data?.data);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("API call failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [token, setLoading, logout]);

  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();
  const currentMonthName = new Date(0, currentMonthIndex).toLocaleString(
    "default",
    { month: "long" }
  );
  const [formData, setFormData] = useState({
    leaveYear: currentYear.toString(),
    leaveMonth: currentMonthName,
    statusType: "ALL Data",
  });

  useEffect(() => {
    const filterLeaveData = () => {
      if (formData.statusType === "ALL Data") {
        const allData = attendanceData?.filter((leave) => {
          return (
            leave.year === formData.leaveYear &&
            leave.month === formData.leaveMonth
          );
        });

        setFilteredLeaveData(allData);
        getCountAttendanceDarta(allData);
      } else {
        const filteredData = attendanceData?.filter((leave) => {
          return (
            leave.year === formData.leaveYear &&
            leave.month === formData.leaveMonth &&
            // leave.attendance_status === formData.statusType
            (leave.attendance_status === formData.statusType ||
              leave.work_status == formData.statusType)
          );
        });
        setFilteredLeaveData(filteredData);
        getCountAttendanceDarta(filteredData);
      }
    };

    filterLeaveData();
  }, [
    formData.leaveYear,
    formData.leaveMonth,
    formData.statusType,
    attendanceData,
  ]);
  const getCountAttendanceDarta = (data) => {
    let leaveCount = 0;
    let halfDayCount = 0;
    let lateCount = 0;
    let onTimeCount = 0;
    let weekOff = 0;

    data?.forEach((item) => {
      // //console.log("item", item);
      if (item?.attendance_status === "Leave") {
        leaveCount += 1;
      } else if (item?.attendance_status === "Half-Day") {
        halfDayCount += 1;
      } else if (item?.attendance_status === "Late") {
        lateCount += 1;
      } else if (item?.attendance_status === "On Time") {
        onTimeCount += 1;
      } else if (item?.attendance_status === "Week Off") {
        weekOff += 1;
      }
    });
    setcountData({
      leave: leaveCount,
      onTime: onTimeCount,
      halfDay: halfDayCount,
      late: lateCount,
      weekOff: weekOff,
    });
  };
  useEffect(() => {
    if (employeeId && (!profileData?.name)) {
      dispatch(getEmployeeProfile(employeeId))
    }
  }, []);
  useEffect(() => {
    fetchEmployeeAttendance();
  }, []);
  const handleYearChange = (e) => {
    setIsDisabled(false);
    setIsFilterApplied(true);
    setFormData({ ...formData, leaveYear: e.target.value });
  };
  const handleMonthChange = (e) => {
    setIsDisabled(false);
    setIsFilterApplied(true);
    setFormData({ ...formData, leaveMonth: e.target.value });
  };

  const handalEmployeeStatus = (e) => {
    setIsDisabled(false);
    setIsFilterApplied(true);
    setFormData({ ...formData, statusType: e.target.value });
  };
  const generateYears = () => {
    const years = [];
    for (let year = 2020; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };

  const generateMonths = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    if (formData.leaveYear === currentYear.toString()) {
      return months.slice(0, currentMonthIndex + 1);
    }
    return months;
  };
  const getTotalLate = (data) => {
    const totalLate = data.filter(
      (entry) => entry.attendance_status == "Late"
    ).length;
    return totalLate;
  };

  const getRowStyle = (data) => {
    const { type, attendance_status } = data;

    let style = {};
    // attendance_status replaced by type or color changes
    // //console.log("type" ,type ,data);


    if (attendance_status === "Leave") {
      style = {
        width: 10,
        height: 50,
        background: "#DE232A",
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    } else if (attendance_status === "Half-Day") {
      style = {
        width: 10,
        height: 50,
        background: "#1E40AF",
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    } else if (attendance_status === "Week Off") {
      style = {
        width: 10,
        height: 50,
        background: "#8CC4FF",
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    } else if (attendance_status === "Late") {
      style = {
        width: 10,
        height: 50,
        background: "#FFCC00",
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    } else if (attendance_status === "On Time") {
      style = {
        width: 10,
        height: 50,
        background: "#009A20",
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    } else {
      style = {
        width: 10,
        height: 50,
        marginRight: 20,
        marginLeft: -8,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      };
    }
    // //console.log("style" ,style);
    return style;
  };

  const handleClickOpen = (image) => {
    setSelectedImage(image || null);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const handleClearFilter = () => {
    setFormData({
      leaveYear: currentYear.toString(),
      leaveMonth: currentMonthName,
      statusType: "ALL Data",
    });
    setIsDisabled(true);
    setIsFilterApplied(false);
  };
  const handleRefresh = async () => {
    fetchEmployeeAttendance();
  };
  const columns = [
    {
      title: "S.NO",
      dataIndex: "sn",
      width: 80,
      key: "sn",
      render: (_, record, index) => (
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={getRowStyle(record)}></div>
          {index + 1}
        </div>
      ),
    },
    {
      title: "REPORTING MANAGER",
      dataIndex: "reporting_manager",
      filterMultiple: true,
      width: 200,
      key: "reporting_manager",
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "20px",
            color: COLOR.GRAY4,
          }}
        >
          {text}
        </span>
      ),
    },

    {
      title: "EMP. STATUS",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "600",
            fontSize: "14px",
            lineHeight: "20px",
            color: COLOR.GRAY4,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "DAY",
      dataIndex: "day",
      key: "day",
      width: 150,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },

    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      width: 150,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "MONTH",
      dataIndex: "month",
      key: "month",
      width: 150,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "YEAR",
      dataIndex: "year",
      key: "year",
      width: 120,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
 {
      title: "PRODUCTION HOURS",
      // dataIndex: "login_time",
      // key: "login_time",
      width: 200,
      render: (rdata) => (
        <div>
          {
            rdata?.prod_hrs &&
            <span className="d-flex small gap-1 justify-content-center rounded text-white align-items-center"
              style={{
                background: `${convertToDecimalHours(rdata?.prod_hrs) < 9 ? "red" : "#03c95a"}`,
                maxWidth: "80px",
                padding:"2px auto"
              }}
            >
              <i className="ti ti-clock-hour-11 " />
              {
                rdata?.prod_hrs ? convertToDecimalHours(rdata?.prod_hrs).toFixed(2) + " Hrs" : ""
              }
            </span>
          }
        </div>
      ),
    },
    {
      title: "IN TIME",
      dataIndex: "login_time",
      key: "login_time",
      width: 120,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
   
    {
      title: "IMAGE IN",
      dataIndex: "login_image",
      key: "login_image",
      width: 120,
      render: (img) =>
        img ? (
          <img
            src={ImagePath1 + img}
            style={{ width: 40, height: 40, borderRadius: "5px" }}
            onClick={() => handleClickOpen(img)}
          />
        ) : (
          <img
            src={IMAGE.NOIMAGE}
            style={{ width: 40, height: 40, borderRadius: "5px" }}
          />
        ),
    },
    {
      title: "OUT TIME",
      dataIndex: "logout_time",
      key: "logout_time",
      width: 120,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "IMAGE OUT",
      dataIndex: "logout_image",
      key: "logout_image",
      width: 120,
      render: (img) =>
        img ? (
          <img
            src={ImagePath1 + img}
            style={{ width: 40, height: 40, borderRadius: "5px" }}
            onClick={() => handleClickOpen(img)}
          />
        ) : (
          <img
            src={IMAGE.NOIMAGE}
            style={{ width: 40, height: 40, borderRadius: "5px" }}
          />
        ),
    },
    {
      title: "STATUS",
      dataIndex: "attendance_status",
      key: "status",
      width: 120,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "WORK STATUS",
      dataIndex: "work_status",
      key: "work_status",
      width: 150,
      render: (text) => (
        <span
          style={{
            //fontFamily: "Inter",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "22px",
            color: COLOR.GRAY3,
          }}
        >
          {text}
        </span>
      ),
    },
  ];

  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="content">
          <h2
            style={{
              marginBottom: "10px",
              marginTop: "10px",
              fontSize: "24px",
              fontWeight: "700",
              //fontFamily: "Inter",
              color: COLOR.BLACK,
            }}
          >
            Attendance Sheet
          </h2>

          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                maxHeight: "90vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              <ProfileDetailsCard ChildComponent="true" style={{ top: "0", width: "100%" }} attendanceData={attendanceData} formData={formData} position="relative" />
              <PullToRefresh onRefresh={handleRefresh} canFetchMore={true}>
                <div className="p-4 rounded-lg bg-white shadow-sm mt-5">
                  <div className="flex items-center justify-content-end ">

                    <div className="flex items-center space-x-4 ">
                      <div>
                        <span
                          className="mr-2"
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.GRAY3,
                            lineHeight: "18px",
                          }}
                        >
                          Current Year
                        </span>

                        <select
                          name="experience"
                          id="experience"
                          value={formData.leaveYear}
                          onChange={handleYearChange}
                          required
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK,
                            lineHeight: "18px",
                          }}
                        >
                          {generateYears().map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <span
                          className="mr-2"
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.GRAY3,
                            lineHeight: "18px",
                          }}
                        >
                          Month
                        </span>

                        <select
                          id="experience"
                          value={formData.leaveMonth}
                          onChange={handleMonthChange}
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK,
                            lineHeight: "18px",
                          }}
                        >
                          {generateMonths().map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <span
                          className="mr-2"
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.GRAY3,
                            lineHeight: "18px",
                          }}
                        >
                          Status
                        </span>

                        <select
                          name="statusType"
                          id="statusType"
                          value={formData.statusType}
                          onChange={handalEmployeeStatus}
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            //fontFamily: "Inter",
                            color: COLOR.BLACK,
                            lineHeight: "18px",
                          }}
                        >
                          <option value="ALL Data">All Data</option>
                          <option value="On Time">On Time</option>
                          <option value="Late">Late</option>
                          <option value="Leave">Leave</option>
                          <option value="Half-Day">Half-Day</option>
                          <option value="WFH">WFH</option>
                        </select>
                      </div>

                      <button
                        onClick={handleClearFilter}
                        disabled={isDisabled}
                        className={`px-3 py-1 rounded flex items-center justify-center transition-colors ${isFilterApplied
                          ? "bg-blue-500 text-white hover:bg-blue-600"
                          : "bg-gray-200 text-black"
                          } ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          //fontFamily: "Inter",
                          lineHeight: "18px",
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-end mt-4">
                    <div className="flex space-x-4 items-center">
                      <span className="flex items-center space-x-1 text-sm text-green-600">
                        <span className="w-2 h-2 bg-green-500 rounded-full "></span>
                        <span
                          // className="underline"
                          style={{
                            color: "blue",
                            fontSize: "12px",
                            fontWeight: "400",
                            //fontFamily: "Inter",
                            lineHeight: "20px",
                          }}
                        >
                          On Time({countData?.onTime})
                        </span>
                      </span>
                      <span className="flex items-center space-x-1 text-sm text-blue-600">
                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                        <span
                          // className="underline"
                          style={{
                            color: "blue",
                            fontSize: "12px",
                            fontWeight: "400",
                            //fontFamily: "Inter",
                            lineHeight: "20px",
                          }}
                        >
                          Half Day ({countData?.halfDay})
                        </span>
                      </span>
                      <span className="flex items-center space-x-1 text-sm text-purple-500">
                        <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                        <span
                          // className="underline"
                          style={{
                            color: "blue",
                            fontSize: "12px",
                            fontWeight: "400",
                            //fontFamily: "Inter",
                            lineHeight: "20px",
                          }}
                        >
                          WFH(0)
                        </span>
                      </span>
                      <span className="flex items-center space-x-1 text-sm text-yellow-500">
                        <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
                        <span
                          // className="underline"
                          style={{
                            color: "blue",
                            fontSize: "12px",
                            fontWeight: "400",
                            //fontFamily: "Inter",
                            lineHeight: "20px",
                          }}
                        >
                          Late({countData?.late})
                        </span>
                      </span>
                      <span className="flex items-center space-x-1 text-sm text-red-500">
                        <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                        <span
                          // className="underline"
                          style={{
                            color: "blue",
                            fontSize: "12px",
                            fontWeight: "400",
                            //fontFamily: "Inter",
                            lineHeight: "20px",
                          }}
                        >
                          Leave({countData?.leave})
                        </span>
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      width: "100%",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      overflowX: "auto",
                    }}
                  >
                    <Table
                      className="dotted-border-table"
                      columns={columns}
                      dataSource={filteredLeaveData}
                      style={{ tableLayout: "fixed" }}
                      locale={{
                        emptyText: (
                          <div className="custom-no-data">
                            No Attendance Data Found
                          </div>
                        ),
                      }}
                      pagination={{ pageSize: 8, position: ["bottomRight"] }}
                      rowClassName={() => "custom-row"}
                      bordered={false}
                      // style={{ tableLayout: "auto" }}
                      tableLayout="fixed"
                      rowKey="key"
                      scroll={{ x: 1000 }} // Ensures proper scrolling behavior
                    />
                  </div>
                  <AssetsPreview
                    open={open} handleClose={handleClose}
                    title={"Image Preview"}
                    selectedImage={[{ image: ImagePath1 + selectedImage }]} />
                </div>
              </PullToRefresh>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EmployeeAttendance;
